<template lang="pug">
  .input-with-commas
    el-input(
      @input="handleInput"
      :value="numberWithCommas(numberValue)"
      :placeholder="$t(placeholder)"
      :style="inputStyle"
      :class="{ invalid: isValidate }"
      @blur="$emit('blur')"
      :disabled="disabled"
    )
      span(slot="suffix") {{ $t(unit) }}
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    allowZero: {
      type: Boolean,
      default: false
    },
    value: {},
    unit: {
      type: String,
      default () {
        return ''
      }
    },
    placeholder: {
      type: String,
      default () {
        return ''
      }
    },
    inputStyle: {
      type: String,
      default () {
        return ''
      }
    },
    isValidate: {
      type: Boolean,
      default () {
        return false
      }
    },
    disabled: {
      type: Boolean,
      default () {
        return false
      }
    }
  },
  data () {
    return {
      showTrailingDot: false,
      numberValue: null
    }
  },
  mounted () {
    this.numberValue = this.numberWithoutCommas(this.value)
  },
  watch: {
    value () {
      this.numberValue = this.numberWithoutCommas(this.value)
    }
  },
  methods: {
    handleInput (evt) {
      if (evt.endsWith('.') && evt.slice(0, -1).indexOf('.') === -1) {
        this.showTrailingDot = true
      } else {
        this.showTrailingDot = false
      }

      const oldValue = this.numberValue

      this.numberValue = this.numberWithoutCommas(evt)

      // 如果输入 NaN ，保持原值
      if (isNaN(this.numberValue)) {
        this.$nextTick(_ => { this.numberValue = oldValue })
        this.$emit('change', oldValue)
        return
      }

      this.$emit('change', this.numberValue)
    },

    numberWithCommas (number) {
      if (number == null && !(this.allowZero && number === 0)) return

      if (!number && !(this.allowZero && number === 0)) return null

      const n = Number(number)

      if (Number.isNaN(n)) {
        return number
      }

      const str = String(n).includes('.') ? String(n).split('.')[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + String(n).split('.')[1]
        : String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      return this.showTrailingDot ? str + '.' : str
    },

    numberWithoutCommas (string) {
      if (!string || string === '') return string

      const n = Number(String(string).split(',').join(''))
      if (Number.isNaN(n)) {
        return string
      }
      return n
    }
  }
}
</script>

<style lang="stylus">
.input-with-commas
  .invalid
    > input
      border-color #f56c6c !important
  .el-input__suffix
    display flex
    justify-content center
    align-items center
</style>
